export const GET_USER_ID = 'GET_USER_ID';
export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY';
export const GET_SCHEDULED_PAYMENT = 'GET_SCHEDULED_PAYMENT';
export const GET_TRANSACTIONS_HISTORY = 'GET_TRANSACTIONS_HISTORY';
export const GET_CONTRACTS = 'GET_CONTRACTS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_ACTIVE_TAB = 'GET_ACTIVE_TAB';
export const GET_CUSTOMER_INFORMATION = 'GET_CUSTOMER_INFORMATION';
export const GET_INPROGRESS_PAYMENTS = 'GET_INPROGRESS_PAYMENTS';
export const GET_OTP = 'GET_OTP';
export const GET_TRACE_ID = 'GET_TRACE_ID';
export const GET_USER_DETAIL = 'GET_USER_DETAIL';
export const REMOVE_USER_DETAILS = 'REMOVE_USER_DETAILS';
export const GET_ASSET_INFORMATION = 'GET_ASSET_INFORMATION';
export const GET_MACHINE_HEALTH_DETAILS = 'GET_MACHINE_HEALTH_DETAILS';
export const LOAD_MACHINE_HEALTH_DETAILS = 'LOAD_MACHINE_HEALTH_DETAILS';
export const GET_OFFER_ELIGIBILITY = 'GET_OFFER_ELIGIBILITY';
export const GET_OFFER_ENQUIRY = 'GET_OFFER_ENQUIRY';
export const GET_SKIP_TOUR = 'GET_SKIP_TOUR';
export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';
export const GET_USER_NAME = 'GET_USER_NAME';
export const RESET_PRESERVED_STATE = 'RESET_PRESERVED_STATE';
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';
export const UPDATE_EXPENSE_TOUR_FLAG = 'UPDATE_EXPENSE_TOUR_FLAG';
export const GET_USER_LOCALE = 'GET_USER_LOCALE';
export const UPDATE_TNC_ACCEPTED = 'UPDATE_TNC_ACCEPTED';

//digiDiary views actions type
export const PUSH_DIGIDIARY_VIEW = 'PUSH_DIGIDIARY_VIEW';
export const POP_DIGIDIARY_VIEW = 'POP_DIGIDIARY_VIEW';
export const RESET_DIGIDIARY_VIEW = 'RESET_DIGIDIARY_VIEW';
export const SET_ACTIVE_FOOTER = 'SET_ACTIVE_FOOTER';
export const SHOW_HIDE_FOOTER = 'SHOW_HIDE_FOOTER';
export const DIGIDIARY_FARM_SETUP = 'DIGIDIARY_FARM_SETUP';
export const FARM_INFO_RESET = 'FARM_INFO_RESET';
export const TOTAL_INCOME_YIELD = 'TOTAL_INCOME_YIELD';

//digiDiary equipment setup action type
export const DIGIDIARY_EQUIPMENT_SETUP = 'DIGIDIARY_EQUIPMENT_SETUP';
export const DIGIDIARY_EQUIPMENT_DETAILS_RESET =
  'DIGIDIARY_EQUIPMENT_DETAILS_RESET';
export const SHOW_HIDE_HEADER = 'SHOW_HIDE_HEADER';
export const SET_CROP_VIEW_MODE = 'SET_CROP_VIEW_MODE';
export const SET_EQUIPMENT_VIEW_MODE = 'SET_EQUIPMENT_VIEW_MODE';
export const DIGIDIARY_ADD_EQUIPMENT = 'DIGIDIARY_ADD_EQUIPMENT';
export const SET_SELECTED_CROP_ID = 'SET_SELECTED_CROP_ID';
export const SET_SELECTED_EQUIPMENT_ID = 'SET_SELECTED_EQUIPMENT_ID';

//digiDiary api call actions
export const DIGIDIARY_GET_FARM = 'DIGIDIARY_GET_FARM';
export const DIGIDIARY_ADD_FARM = 'DIGIDIARY_ADD_FARM';
export const DIGIDIARY_SET_LOADER = 'DIGIDIARY_SET_LOADER';
export const DIGIDIARY_SET_ALERT = 'DIGIDIARY_SET_ALERT';
export const DIGIDIARY_RESET_ALERT = 'DIGIDIARY_RESET_ALERT';
export const DIGIDIARY_GET_EXPENSE = 'DIGIDIARY_GET_EXPENSE';
export const DIGIDIARY_UPDATE_TOUR_FLAG = 'DIGIDIARY_UPDATE_TOUR_FLAG';

export const DIGIDIARY_GET_EXPENSE_INFO = 'DIGIDIARY_GET_EXPENSE_INFO';
export const DIGIDIARY_ADD_EDIT_EXPENSE = 'DIGIDIARY_ADD_EDIT_EXPENSE';
export const DIGIDIARY_SET_EXPENSE_TOTAL = 'DIGIDIARY_SET_EXPENSE_TOTAL';
export const DIGIDIARY_ADD_YIELD = 'DIGIDIARY_ADD_YIELD';
export const DIGIDIARY_GET_YIELD = 'DIGIDIARY_GET_YIELD';
export const DIGIDIARY_ADD_INCOME = 'DIGIDIARY_ADD_INCOME';
export const DIGIDIARY_GET_INCOME = 'DIGIDIARY_GET_INCOME';
export const DIGIDIARY_INCOME_TIMESTAMP = 'DIGIDIARY_INCOME_TIMESTAMP';
export const DIGIDIARY_RESET_INCOME_TIMESTAMP =
  'DIGIDIARY_RESET_INCOME_TIMESTAMP';
export const DD_UPDATE_CROP_STATE = 'DD_UPDATE_CROP_STATE';

export const SET_UP_HOME_PAGE = 'DD_SET_UP_HOME_PAGE';
export const SET_UP_HOME_PAGE_loading = 'SET_UP_HOME_PAGE_loading';

export const DD_LOAD_MY_FARM_VIEW = 'DD_LOAD_MY_FARM_VIEW';
export const DD_PUT_MY_FARM_DATA = 'DD_PUT_MY_FARM_DATA';
export const DD_SET_MY_FARM_DATA_LOADING = 'DD_SET_MY_FARM_DATA_LOADING';
export const DD_UPDATE_CROP_DETAILS = 'DD_UPDATE_CROP_DETAILS';
export const DD_UPDATE_IMPLEMENTS_DETAILS = 'DD_UPDATE_IMPLEMENTS_DETAILS';
export const DD_ADD_NEW_CROP = 'DD_ADD_NEW_CROP';
export const DD_PUT_UPDATED_CROP_DETAILS = 'DD_PUT_UPDATED_CROP_DETAILS';
export const DD_PUT_ADD_NEW_CROP_DETAILS = 'DD_PUT_ADD_NEW_CROP_DETAILS';
export const SET_ALL_EQUIPMENT = 'SET_ALL_EQUIPMENT';
export const ADD_CYCLE_ACTIVITY = 'ADD_CYCLE_ACTIVITY';
export const DD_PRE_UPDATE_CROP_DETAILS = 'DD_PRE_UPDATE_CROP_DETAILS';
export const SET_ACTIVITY_MODAL = 'SET_ACTIVITY_MODAL';
export const DIGIDIARY_GET_FARM_DATA = 'DIGIDIARY_GET_FARM_DATA';
export const DIGIDIARY_UPDATE_MY_FARM = 'DIGIDIARY_UPDATE_MY_FARM';
export const DD_LOAD_EXISTING_EQUIPMENT = 'DD_LOAD_EXISTING_EQUIPMENT';
export const DD_PUT_EXISTING_EQUIPMENT_DATA = 'DD_PUT_EXISTING_EQUIPMENT_DATA';
export const DIGIDIARY_SET_API_ERROR = 'DIGIDIARY_SET_API_ERROR';
export const DIGIDIARY_RESET_EQUIPMENT_TYPE = 'DIGIDIARY_RESET_EQUIPMENT_TYPE';
export const DIGIDIARY_TNC_ACCEPTED = 'DIGIDIARY_TNC_ACCEPTED';
export const UPDATE_DD_TNC_ACCEPTED = 'UPDATE_DD_TNC_ACCEPTED';
export const UPDATE_WHATSAPP_OPT_IN_DETAILS = 'UPDATE_WHATSAPP_OPT_IN_DETAILS';
export const UPDATE_POPUP_SEEN_REQUEST = 'UPDATE_POPUP_SEEN_REQUEST';

// Offers Actions

export const LOAD_OFFERS_FOR_MFA_CUSTOMER = 'LOAD_OFFERS_FOR_MFA_CUSTOMER';
export const LOAD_OFFERS_FOR_NON_MFA_CUSTOMER =
  'LOAD_OFFERS_FOR_NON_MFA_CUSTOMER';
export const SET_OFFERS_LOADING = 'SET_OFFERS_LOADING';
export const SET_NON_MFA_OFFERS_LOADING = 'SET_NON_MFA_OFFERS_LOADING';
export const SET_OFFERS_FOR_MFA_CUSTOMER = 'SET_OFFERS_FOR_MFA_CUSTOMER';
export const SET_OFFERS_FOR_MFA_NON_CUSTOMER =
  'SET_OFFERS_FOR_MFA_NON_CUSTOMER';

export const SET_OFFER_FOUND_BY_ID = 'SET_OFFER_FOUND_BY_ID';

export const LOAD_OFFER_BY_ID_NON_MFA_CUSTOMER =
  'LOAD_OFFER_BY_ID_NON_MFA_CUSTOMER';

export const MFA_CUSTOMER_SUBMIT_OFFER_ENQUIRY =
  'MFA_CUSTOMER_SUBMIT_OFFER_ENQUIRY';
export const SET_OFFERS_SUBMITTING = 'SET_OFFERS_SUBMITTING';
export const SET_SELECTED_OFFER_NON_MFA_CUSTOMER =
  'SET_SELECTED_OFFER_NON_MFA_CUSTOMER';

// Personal offer letter

export const LOAD_PERSONAL_OFFER_LETTER_DATA =
  'LOAD_PERSONAL_OFFER_LETTER_DATA';

export const SET_PERSONAL_OFFERS_LETTER_LOADING =
  'SET_PERSONAL_OFFERS_LETTER_LOADING';

export const SET_PERSONAL_OFFERS_LETTER_DATA =
  'SET_PERSONAL_OFFERS_LETTER_DATA';

export const SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY =
  'SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY';

export const SET_SHOW_HIDE_PERSONAL_OFFER_LETTER =
  'SET_SHOW_HIDE_PERSONAL_OFFER_LETTER';

export const SET_USER_SEEN_THE_PERSONAL_OFFER =
  'SET_USER_SEEN_THE_PERSONAL_OFFER';

export const SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD =
  'SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD';

export const SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD =
  'SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD';

export const SET_OFFERS_VIEW = 'SET_OFFERS_VIEW';
export const SET_OFFERS_SUBMIT = 'SET_OFFERS_SUBMIT';

export const UPDATE_USER_SCRATCH_THE_CARD = 'UPDATE_USER_SCRATCH_THE_CARD';
export const SET_CUSTOM_ALERT = 'SET_CUSTOM_ALERT';
//NON MFA Customer Login
export const GET_OTP_NON_MFA_USER = 'GET_OTP_NON_MFA_USER';
export const VERIFY_OTP_NON_MFA_USER = 'VERIFY_OTP_NON_MFA_USER';
export const FETCH_NON_MFA_USER_PROFILE = 'FETCH_NON_MFA_USER_PROFILE';
export const UPDATE_NON_MFA_WHATSAPP_OPTIN = 'UPDATE_NON_MFA_WHATSAPP_OPTIN';
export const SET_NON_MFA_USER_MOBILE_NUMBER = 'SET_NON_MFA_USER_MOBILE_NUMBER';
export const SET_NON_MFA_USER_DATA = 'SET_NON_MFA_USER_DATA';
export const SET_NON_MFA_ALERT = 'SET_NON_MFA_ALERT';
export const RESET_NON_MFA_ALERT = 'RESET_NON_MFA_ALERT';
export const NON_MFA_USER_VERIFICATION_SUCCESS =
  'NON_MFA_USER_VERIFICATION_SUCCESS';
export const NON_MFA_USER_VERIFICATION_FAILURE =
  'NON_MFA_USER_VERIFICATION_FAILURE';
export const NON_MFA_USER_SUBMIT_OFFER = 'NON_MFA_USER_SUBMIT_OFFER';
export const NON_MFA_SET_VIEW = 'NON_MFA_SET_VIEW';

export const LOAD_PREVIOUS_SUBMITTED_OFFERS_NON_MFA =
  'LOAD_PREVIOUS_SUBMITTED_OFFERS_NON_MFA';

export const SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA =
  'SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA';

export const LOAD_USER_DEVICE_PUSH_TOKEN = 'LOAD_USER_DEVICE_PUSH_TOKEN';
export const ASK_USER_TO_ENABLE_PUSH = 'ASK_USER_TO_ENABLE_PUSH';
export const SET_CONFIRM_PAYMENT_DATA = 'SET_CONFIRM_PAYMENT_DATA';

export const GET_ACCOUNTING_PAYMENT_HISTORY = 'GET_ACCOUNTING_PAYMENT_HISTORY';
export const SET_TOTAL_ON_ACCOUNT_PAYMENT = 'SET_TOTAL_ON_ACCOUNT_PAYMENT';
export const SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER =
  'SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER';
export const PAYMENT_HISTORY_UNAVAILABLE = 'PAYMENT_HISTORY_UNAVAILABLE';
